import { baseApi } from "./api"

export const userApi = baseApi.enhanceEndpoints({ addTagTypes: ['Users'] }).injectEndpoints({
    endpoints: (builder) => ({
        getUsers: builder.query({
            query: () => 'user',
            // Provides a list of `Users` by `id`.
            // If any mutation is executed that `invalidate`s any of these tags, this query will re-run to be always up-to-date.
            // The `LIST` id is a "virtual id" we just made up to be able to invalidate this query specifically if a new `Users` element was added.
            providesTags: (result) =>
                // is result available?
                result
                    ? // successful query
                    [
                        ...result.map(({ _id }) => ({ type: 'Users', id: _id })),
                        { type: 'Users', id: 'LIST' },
                    ]
                    : // an error occurred, but we still want to refetch this query when `{ type: 'Users', id: 'LIST' }` is invalidated
                    [{ type: 'Users', id: 'LIST' }],
        }),
        updateUser: builder.mutation({
            query(data) {

                const { _id, ...body} = data;

                return {
                    url: `user/${_id}`,
                    method: 'PUT',
                    body,
                }
            },
            // Invalidates all queries that subscribe to this Plot `id` only.
            // In this case, `getPlot` will be re-run. `getPlots` *might*  rerun, if this id was under its results.
            invalidatesTags: (result, error, { _id }) => error?[]:[{ type: 'Users', id: _id },{ type: 'Users', id: 'LIST' }],
        }),
    }),
})

export const {
    useGetUsersQuery,
    useUpdateUserMutation,
} = userApi;